import { render, staticRenderFns } from "./storage_distribution_list.vue?vue&type=template&id=33f5948f"
import script from "./storage_distribution_list.vue?vue&type=script&lang=js"
export * from "./storage_distribution_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports